import React, { Component } from 'react';
import { Col, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap';
import Api from '../../../../Global/Modules/Api'
const FETCH_URL = "api/courses/"
class RefferalSearch extends Component {
    constructor(props) {
        super(props)
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            reference: '',
            institute: "Instituut naam a.d.h. van het nr",
            name: "naam a.d.h. van het nr"
        }
    }
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ [name]: value })
    }

    handleClick(event) {
        event.preventDefault()
        // TODO: Post payload to the API
        var reference = this.state.reference.replace("#", "");
        if (reference !== '') {
            Api.GetApi(FETCH_URL + reference + '/reference').then(data => {
                if (data.course != null) {
                    this.props.onUpdate('course', data.course.id)
                    this.props.onUpdate('points', data.course.points) // Notify the points change to the parent
                    this.props.onUpdate('diploma', data.course.diploma)
                    this.setState({ institute: data.course.institution })
                    this.setState({ name: data.course.name })
                }

            })
        } else {
            this.props.onUpdate('course', 0)
            this.props.onUpdate('points', 0) // Notify the points change to the parent
            this.props.onUpdate('diploma', '')
        }



    }
    render() {
        return (
            <div>
                {/* TODO: Create search on Referentienummer. in all courses en knowledge to add, and filter this per type of page. */}
                <FormGroup controlId="refferalSearchBox">
                    <Col componentClass={ControlLabel} sm={4}>
                        Referentienummer
                            </Col>
                    <Col sm={4}>
                        <FormControl type="text" name="reference" onChange={this.handleChange} />
                    </Col>
                    <Col md={4}>
                        <Button onClick={this.handleClick}>controleer nr</Button>
                    </Col>
                </FormGroup>
                <FormGroup controlId="refferalSearchBoxcomponentClass">
                    <Col componentClass={ControlLabel} sm={4}>
                        Instituut
                            </Col>
                    <Col sm={8}>
                        <FormControl.Static><i>{this.state.institute}</i></FormControl.Static>
                    </Col>
                </FormGroup>
                <FormGroup controlId="refferalSearchBoxCursus">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam
                            </Col>
                    <Col sm={8}>
                        <FormControl.Static><i>{this.state.name}</i></FormControl.Static>
                    </Col>
                </FormGroup>

            </div>
        )
    };

}

export default RefferalSearch;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/Toevoegen/RefferalSearch.js